import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import posthog from "posthog-js";
import {
  PostHogErrorBoundary,
  setupReactErrorHandler,
  type PostHogErrorBoundaryFallbackProps,
} from "posthog-js/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { initTelemetry } from "./lib/telemetry";
import "./index.css";

initTelemetry();

function AppErrorFallback({ resetError }: PostHogErrorBoundaryFallbackProps) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-8">
      <div className="max-w-md rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-6 text-center shadow-sm">
        <h1 className="text-xl font-semibold tracking-tight text-[var(--ink-primary)]">
          Ocurrió un error inesperado
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-[hsl(var(--muted-foreground))]">
          El error fue reportado. Reintentá cargar la aplicación.
        </p>
        <button
          className="mt-5 inline-flex h-10 items-center justify-center rounded-lg bg-[var(--ink-primary)] px-4 text-sm font-medium text-[var(--accent-raw)]"
          onClick={resetError}
          type="button"
        >
          Reintentar
        </button>
      </div>
    </div>
  );
}

createRoot(document.getElementById("root")!, {
  onUncaughtError: setupReactErrorHandler(posthog),
  onRecoverableError: setupReactErrorHandler(posthog),
}).render(
  <StrictMode>
    <BrowserRouter>
      <PostHogErrorBoundary fallback={AppErrorFallback}>
        <App />
      </PostHogErrorBoundary>
    </BrowserRouter>
  </StrictMode>
);
